import { render, staticRenderFns } from "./PicUploader.vue?vue&type=template&id=151dc828&scoped=true"
import script from "./PicUploader.vue?vue&type=script&lang=js"
export * from "./PicUploader.vue?vue&type=script&lang=js"
import style0 from "./PicUploader.vue?vue&type=style&index=0&id=151dc828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151dc828",
  null
  
)

export default component.exports